<template>
    <Modal class="confirm-modal-small" :is_show="is_show_add_modal" @click-bg="close(false)"
        :class="{ 'is-loading': is_loading }">
        <div class="contain-box-confirm">
            <div class="confirm-title">{{ confirm_contain.title }}</div>
            <div class="text">{{ confirm_contain.text }}</div>

            <div class="confirm-btn-box">
                <Button type="button" color="no-color" size="40" @click.native="close">No</Button>
                <Button type="button" color="dark-blue" size="40" @click.native="save">Confirm</Button>
            </div>
        </div>
    </Modal>
</template>

<script>
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';

export default {
    name: 'DomainConfirm',

    components: {
        Button,
        Modal,
    },

    props: {
        is_edit: {
            type: Boolean,
            default: false
        },
        
        sub_url: {
            type: String,
            default: 'www.brand.com'
        }
    },

    data() {
        return {
            key_refrash: 0,
            is_show_add_modal: false,
            is_loading: false,
            //step1=>Connection in progress
            //step2=>Connection to new
            //step3=>disConnection
            step: 1,
            url: '',
        }
    },
    computed: {
        confirm_contain() {

            if (this.step === 1) {
                return {
                    title: 'Disconnect domain?',
                    text: `This action cannot be undone.`
                }
            }else if(this.step === 2){
                return {
                    title: 'Remove fallback URL?',
                    text: `You can edit this later.`
                }
            }

        }
    },


    methods: {

        open(val) {
            this.is_show_add_modal = true;
            this.step = val.step;
            this.url = val.url;
            this.key_refrash += 1;
        },

        save() {
            if (this.step === 1) {
                this.$emit('newSubDomain', null);
                this.close();

            }else if(this.step===2){
                this.$emit('delFallBack');
                this.close();
            }
        },

        close() {
            this.is_show_add_modal = false;
        },

        errNofity(err) {
            let mes = err.response && err.response.data.data ? err.response.data.data.message : '';
            this.$notify(`<svg class="err-notify"><use xlink:href="#alert--sprite"></use></svg> Change fail.${mes}`);
        },

    },

    mounted() {
    }

}
</script>
<style lang="scss">
.sub-confirm {

    &.is-loading {
        .user-form-wrap {
            opacity: .5;
            pointer-events: none;

        }
    }

}
</style> 

